var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgAppleSolid = function SvgAppleSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "auto",
    height: "auto",
    viewBox: "0 0 19 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.388 12.887a5.145 5.145 0 0 1 2.45-4.318 5.267 5.267 0 0 0-4.15-2.244c-1.746-.183-3.44 1.045-4.33 1.045-.906 0-2.276-1.027-3.752-.996A5.527 5.527 0 0 0 .955 9.21c-2.011 3.482-.511 8.599 1.416 11.414.963 1.378 2.09 2.917 3.564 2.863 1.442-.06 1.981-.92 3.722-.92 1.725 0 2.23.92 3.734.885 1.548-.025 2.523-1.384 3.453-2.776a11.403 11.403 0 0 0 1.58-3.215 4.973 4.973 0 0 1-3.036-4.575ZM12.547 4.474a5.067 5.067 0 0 0 1.159-3.63A5.155 5.155 0 0 0 10.37 2.57a4.822 4.822 0 0 0-1.189 3.495 4.263 4.263 0 0 0 3.366-1.591Z",
    fill: "currentColor"
  })));
};

export default SvgAppleSolid;